export default function Pricing() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const pricingPlans = [
    {
      name: 'STUDIO SESSIONS',
      price: 'R350',
      period: '/HR',
      borderColor: '#ff6b35',
      buttonBg: '#ff6b35',
      buttonText: 'black',
      features: [
        'Professional Recording',
        'Mixing & Mastering',
        'Beat Production',
        'Vocal Coaching',
        'Studio Engineer Included',
        'High-Quality Equipment'
      ]
    },
    {
      name: 'DESIGN SERVICES',
      price: 'FROM R250',
      period: '',
      borderColor: '#00d9ff',
      buttonBg: 'black',
      buttonText: 'white',
      featured: true,
      features: [
        'Custom Logo Design',
        'Brand Identity Package',
        'Social Media Graphics',
        'Print Materials',
        'Unlimited Revisions',
        'Source Files Included'
      ]
    },
    {
      name: 'POST PRODUCTION',
      price: 'CUSTOM',
      period: '',
      borderColor: '#d4af37',
      buttonBg: 'transparent',
      buttonText: '#d4af37',
      features: [
        'Audio Editing',
        'Sound Design',
        'Final Mix & Master',
        'Audio Cleanup',
        'Sync Preparation',
        'Fast Turnaround'
      ]
    }
  ];

  return (
    <section id="pricing" className="py-24 px-6 bg-[#0a0f1c] relative overflow-hidden">
      {/* Diagonal Stripe Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'repeating-linear-gradient(45deg, transparent, transparent 35px, rgba(255,255,255,0.1) 35px, rgba(255,255,255,0.1) 70px)'
        }}></div>
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="text-gray-400 text-sm font-semibold tracking-widest mb-4">(TRANSPARENT PRICING)</div>
          <h2 className="text-5xl md:text-6xl font-bold text-white">INVEST IN QUALITY</h2>
        </div>

        {/* Pricing Cards */}
        <div className="grid md:grid-cols-3 gap-8">
          {pricingPlans.map((plan, index) => (
            <div 
              key={index}
              className={`rounded-[32px] p-12 transition-all duration-500 hover:transform hover:scale-105 ${
                plan.featured 
                  ? 'bg-white shadow-2xl' 
                  : 'bg-black border-t-[6px]'
              }`}
              style={!plan.featured ? { borderTopColor: plan.borderColor } : {}}
            >
              <h3 className={`text-2xl font-bold mb-6 ${plan.featured ? 'text-black' : 'text-white'}`}>
                {plan.name}
              </h3>

              <div className="mb-8">
                <div className={`text-5xl font-black ${plan.featured ? 'text-black' : 'text-white'}`}>
                  {plan.price}
                  {plan.period && <span className="text-2xl font-normal">{plan.period}</span>}
                </div>
              </div>

              <ul className="space-y-4 mb-10">
                {plan.features.map((feature, idx) => (
                  <li key={idx} className={`flex items-start space-x-3 ${plan.featured ? 'text-gray-700' : 'text-gray-300'}`}>
                    <i 
                      className="ri-check-line text-xl mt-0.5 flex-shrink-0"
                      style={{ color: plan.borderColor }}
                    ></i>
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>

              <button 
                onClick={() => scrollToSection('contact')}
                className={`w-full py-4 rounded-full font-bold transition-all duration-300 whitespace-nowrap cursor-pointer ${
                  plan.featured
                    ? 'bg-black text-white hover:bg-gray-800'
                    : plan.buttonBg === 'transparent'
                    ? 'border-2 hover:bg-white/5'
                    : 'hover:opacity-90'
                }`}
                style={
                  plan.buttonBg === 'transparent'
                    ? { borderColor: plan.borderColor, color: plan.buttonText, backgroundColor: 'transparent' }
                    : { backgroundColor: plan.buttonBg, color: plan.buttonText }
                }
              >
                BOOK NOW
              </button>
            </div>
          ))}
        </div>

        {/* Additional Info */}
        <div className="mt-16 text-center">
          <p className="text-gray-400 text-lg mb-6">
            Need a custom package? We offer flexible pricing for long-term projects and bulk services.
          </p>
          <button 
            onClick={() => scrollToSection('contact')}
            className="text-[#00d9ff] font-semibold hover:underline cursor-pointer whitespace-nowrap"
          >
            Contact us for a personalized quote →
          </button>
        </div>
      </div>
    </section>
  );
}
